import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ManagerErrorHistoryService {
  private storeErrorHistorySubject = new BehaviorSubject<
    Map<string, string | null>
  >(new Map());

  addOrUpdateErrorHistory(service: string, error: any | string | null) {
    let errorResponse = error;
    if (error !== null && typeof error !== 'string') {
      errorResponse = JSON.stringify(error);
    }

    const store = this.storeErrorHistorySubject.getValue();
    store.set(service, errorResponse);
    this.storeErrorHistorySubject.next(store);
  }

  removeErrorHistory(service: string) {
    const store = this.storeErrorHistorySubject.getValue();
    store.delete(service);
    this.storeErrorHistorySubject.next(store);
  }

  getItemErrorHistory(service: string): {
    errorResponse: string | null;
    error: string | null;
  } {
    const store = this.storeErrorHistorySubject.getValue();
    if (!store.has(service)) {
      return { errorResponse: '', error: 'No se encontró el servicio' };
    }
    const item = store.get(service) ?? null;
    return { errorResponse: item, error: null };
  }

  getItemErrorHistoryDinamic(service: string): Observable<string | null> {
    return this.storeErrorHistorySubject.pipe(
      filter((store) => store.has(service)),
      map((store) => store.get(service) ?? null)
    );
  }
}
